import React, { useEffect, useRef, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Breadcrumbs,
} from '../Css/ChartList.styles';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { SectionFormLabel } from 'Settings/FirstUsageSettings/styles';
import {
	SingleFilterWrapper,
	FilterWrapper,
} from 'CategoryManagement/CategoryWidget/SkuAnalysis/MultisourceSkuData/MultisourceSkuData.styles';
import MultiSelect from 'CategoryManagement/CategoryWidget/SkuAnalysis/MultisourceSkuData/components/MultiSelect';
import { ButtonWrapper } from 'Download/styles';
import {
	checkAndFormat,
	checkAndFormatSuppliers,
	filterInitialOptions,
} from 'CategoryManagement/CategoryWidget/utils';
import {
	getChartDataForMarketAnalysis,
	getDatesSKU,
	getModuleFilter,
	getSuppliersForMarketAnalysis,
} from 'utils/apiRequests';
import { filter, isNull } from 'lodash';
import ExpandedModal from '../../Components/ExpandedModal';
import { DateRangeWrapper } from '../../../CategoryDashboard.styles';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import {
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
} from 'CategoryManagement/utils';
import moment from 'moment';

const MarketEffectLineChart = ({ modelId, setContent }) => {
	const [filterData, setFilterData] = useState(
		localStorage.getItem(`marketFilters-${modelId}`) === null
			? filterInitialOptions
			: JSON.parse(localStorage.getItem(`marketFilters-${modelId}`))
	);
	const [isFilterLoading, setIsFilterLoading] = useState(false);
	const [marketChartData, setMarketChartData] = useState(
		localStorage.getItem(`marketData-${modelId}`) === null
			? []
			: JSON.parse(localStorage.getItem(`marketData-${modelId}`))
	);
	const [showSupplierModal, setShowSupplierModal] = useState(false);
	const [supplierLoading, setSupplierLoading] = useState(false);
	const options = {
		chart: {
			type: 'line',
			height: '30%',
		},
		exporting: {
			enabled: false,
			allowHTML: true,
		},
		credits: {
			enabled: false,
		},
		title: {
			text: '',
		},
		legend: {
			align: 'center',
			padding: 0,
		},
		xAxis: {
			title: {
				text: 'Year and Month',
			},
			type: 'datetime',
			crosshair: true,
			lineColor: '#000000',
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			gridLineWidth: 0,
		},
		yAxis: {
			title: {
				text: 'Weight Index',
			},
			gridLineWidth: 0,
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: '#333333',
				},
			},
			lineColor: '#000000',
			lineWidth: 1,
		},
		tooltip: {
			shared: true,
			useHTML: true,
		},
		plotOptions: {
			column: {
				pointPadding: 0.2,
				borderWidth: 0,
			},
		},
		colors: ['#032E45', '#448EB4', '#45B9F7', '#AFE1FC'],
		series: marketChartData,
	};
	const chartRef = useRef();
	useEffect(() => {
		if (localStorage.getItem(`marketData-${modelId}`) === null) {
			setIsFilterLoading(true);
			const payload = {
				modelId: modelId,
			};
			try {
				Promise.all([getModuleFilter(payload), getDatesSKU()])
					.then(([filterResponse, dateResponse]) => {
						const formatedCategory1Options = checkAndFormat(
							filterResponse.data.category1
						);
						const formatedCategory2Options = checkAndFormat(
							filterResponse.data.category2
						);
						const formatedCategory3Options = checkAndFormat(
							filterResponse.data.category3
						);
						const formatedCommodityCodeOptions = checkAndFormat(
							filterResponse.data.commodityCode
						);
						const formatedcommodityFamilyOptions = checkAndFormat(
							filterResponse.data.commodityFamily
						);
						const minDate = dateResponse?.data?.minDate.split('T')[0];
						const maxDate = dateResponse?.data?.maxDate.split('T')[0];
						const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
						const selectedRange = getDateRangeMonthYearState(minDate, maxDate);
						setFilterData(prevState => ({
							...prevState,
							category_1: {
								...prevState.category_1,
								options: formatedCategory1Options,
								selectedOption: [filterResponse.data.category1[0]],
							},
							category_2: {
								...prevState.category_2,
								options: formatedCategory2Options,
								selectedOption: [],
							},
							category_3: {
								...prevState.category_3,
								options: formatedCategory3Options,
								selectedOption: [],
							},
							commodity_Code: {
								...prevState.commodity_Code,
								options: formatedCommodityCodeOptions,
								selectedOption: [],
							},
							commodity_Family: {
								...prevState.commodity_Family,
								options: formatedcommodityFamilyOptions,
								selectedOption: [],
							},
							dateRange: {
								srcRange: wholeRange,
								stateRange: selectedRange,
							},
							//
						}));
						return { response: filterResponse.data, dateResponse };
					})
					.then(async ({ response, dateResponse }) => {
						return await getSuppliersForMarketAnalysis({
							category1: [response.category1[0]],
						}).then(response => {
							const formattedSupplierArray = response.data;
							const formatedSupplierOptions = checkAndFormatSuppliers(
								formattedSupplierArray
							);
							setFilterData(prevState => ({
								...prevState,
								supplier: {
									...prevState.supplier,
									options: formatedSupplierOptions,
									selectedOption: [formattedSupplierArray[0].supplier] || [],
								},

								//
							}));
							return { data: formattedSupplierArray, dateResponse };
						});
					})
					.then(async ({ data, dateResponse }) => {
						await getChartDataForMarketAnalysis({
							supplier: [data[0].supplier],
							startDate: moment(
								dateResponse?.data?.minDate.split('T')[0],
								'YYYY-MM-DD'
							).format('DD-MM-YYYY'),
							endDate: moment(
								dateResponse?.data?.maxDate.split('T')[0],
								'YYYY-MM-DD'
							).format('DD-MM-YYYY'),
						}).then(response => {
							if (response.succeeded) {
								if (!isNull(response.data)) {
									if (Object.keys(response.data).length > 0) {
										const marketAnalysisChartData = response.data.reduce(
											(acc, item) => {
												const existingSupplier = acc.find(
													s => s.name === item.supplier
												);
												const xValue = `${item.year}-${String(
													item.month
												).padStart(2, '0') + '-01'}`;
												const yValue = item.weighted_Average;

												if (existingSupplier) {
													existingSupplier.data.push([
														new Date(xValue).getTime(),
														yValue,
													]);
												} else {
													acc.push({
														type: 'line',
														name: item.supplier,
														data: [[new Date(xValue).getTime(), yValue]],
													});
												}

												return acc;
											},
											[]
										);
										setMarketChartData(marketAnalysisChartData);
										setIsFilterLoading(false);
									}
								}
							}
						});
					});
			} catch (error) {
				console.log(error);
				setIsFilterLoading(false);
			}
		}
	}, []);
	useEffect(
		() => {
			if (
				localStorage.getItem(`marketFilters-${modelId}`) === null &&
				localStorage.getItem(`marketData-${modelId}`) === null
			) {
				localStorage.setItem(
					`marketFilters-${modelId}`,
					JSON.stringify(filterData)
				);
				localStorage.setItem(
					`marketData-${modelId}`,
					JSON.stringify(marketChartData)
				);
			}
		},
		[filterData, marketChartData]
	);

	const handleGetSuppliers = async filters => {
		setSupplierLoading(true);
		await getSuppliersForMarketAnalysis({
			category1: filters.category_1.selectedOption,
			category2: filters.category_2.selectedOption,
			category3: filters.category_3.selectedOption,
			commodityFamily: filters.commodity_Family.selectedOption,
			commodityCode: filters.commodity_Code.selectedOption,
		})
			.then(response => {
				const formattedSupplierArray = response.data;
				const formatedSupplierOptions = checkAndFormatSuppliers(
					formattedSupplierArray
				);
				setFilterData(prevState => ({
					...prevState,
					supplier: {
						...prevState.supplier,
						options: formatedSupplierOptions,
						selectedOption: [formattedSupplierArray[0].supplier] || [],
					},
				}));
			})
			.then(() => {
				setSupplierLoading(false);
			})
			.catch(() => {
				setSupplierLoading(false);
			});
	};
	const handleGetMarketAnalysis = async () => {
		await getChartDataForMarketAnalysis({
			supplier: filterData.supplier.selectedOption,
			startDate:
				'01' +
				'-' +
				filterData.dateRange.stateRange.from.monthNumber +
				'-' +
				filterData.dateRange.stateRange.from.year,
			endDate:
				'01' +
				'-' +
				filterData.dateRange.stateRange.to.monthNumber +
				'-' +
				filterData.dateRange.stateRange.to.year,
		}).then(response => {
			const marketAnalysisChartData = response.data.reduce((acc, item) => {
				const existingSupplier = acc.find(s => s.name === item.supplier);
				const xValue = `${item.year}-${String(item.month).padStart(2, '0') +
					'-01'}`;
				const yValue = item.weighted_Average;

				if (existingSupplier) {
					existingSupplier.data.push([new Date(xValue).getTime(), yValue]);
				} else {
					acc.push({
						type: 'line',
						name: item.supplier,
						data: [[new Date(xValue).getTime(), yValue]],
					});
				}

				return acc;
			}, []);
			setMarketChartData(marketAnalysisChartData);
			localStorage.setItem(
				`marketData-${modelId}`,
				JSON.stringify(marketAnalysisChartData)
			);
		});
		setShowSupplierModal(false);
	};

	const onFilterChangeHandler = (key, value) => {
		setFilterData(prevState => {
			if (key !== 'supplier') {
				handleGetSuppliers({
					...prevState,
					[key]: {
						...prevState[key],
						selectedOption: value,
					},
				});
			}
			localStorage.setItem(
				`marketFilters-${modelId}`,
				JSON.stringify({
					...prevState,
					[key]: {
						...prevState[key],
						selectedOption: value,
					},
				})
			);

			return {
				...prevState,
				[key]: {
					...prevState[key],
					selectedOption: value,
				},
			};
		});
	};

	return (
		<SectionWrapper>
			<Breadcrumbs>
				<span onClick={() => setContent(0)}>Segmented Data</span>&nbsp;/&nbsp;<span
				>
					Market Effect Analysis
				</span>
			</Breadcrumbs>
			{isFilterLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{marketChartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							{showSupplierModal && (
								<ExpandedModal
									heading={'Select Suppliers'}
									handleClose={setShowSupplierModal}
								>
									<Header>
										<FilterWrapper>
											<SingleFilterWrapper>
												<SectionFormLabel>Category 1</SectionFormLabel>
												<MultiSelect
													name="category_1"
													label="Category 1"
													options={filterData.category_1.options}
													selected={filterData.category_1.selectedOption}
													disabled={false}
													isLoading={false}
													onChange={v => {
														onFilterChangeHandler('category_1', v);
													}}
												/>
											</SingleFilterWrapper>

											<SingleFilterWrapper>
												<SectionFormLabel>Category 2</SectionFormLabel>
												<MultiSelect
													name="category_2"
													label="Category 2"
													options={filterData.category_2.options}
													selected={filterData.category_2.selectedOption}
													disabled={false}
													isLoading={false}
													onChange={v => {
														onFilterChangeHandler('category_2', v);
													}}
												/>
											</SingleFilterWrapper>

											<SingleFilterWrapper>
												<SectionFormLabel>Category 3</SectionFormLabel>
												<MultiSelect
													name="category_3"
													label="Category 3"
													options={filterData.category_3.options}
													selected={filterData.category_3.selectedOption}
													disabled={false}
													isLoading={false}
													onChange={v => {
														onFilterChangeHandler('category_3', v);
													}}
												/>
											</SingleFilterWrapper>

											<SingleFilterWrapper>
												<SectionFormLabel>Commodity Code </SectionFormLabel>
												<MultiSelect
													name="commodity_code"
													label="Commodity Code"
													options={filterData.commodity_Code.options}
													selected={filterData.commodity_Code.selectedOption}
													disabled={false}
													isLoading={false}
													onChange={v => {
														onFilterChangeHandler('commodity_Code', v);
													}}
												/>
											</SingleFilterWrapper>

											<SingleFilterWrapper>
												<SectionFormLabel>Commodity Family</SectionFormLabel>
												<MultiSelect
													name="commodity_family"
													label="Commodity Family"
													options={filterData.commodity_Family.options}
													selected={filterData.commodity_Family.selectedOption}
													disabled={false}
													isLoading={false}
													onChange={v => {
														onFilterChangeHandler('commodity_Family', v);
													}}
												/>
											</SingleFilterWrapper>
											<SingleFilterWrapper>
												<SectionFormLabel>Supplier</SectionFormLabel>
												<MultiSelect
													name="supplier"
													label="Select Supplier"
													options={filterData.supplier.options}
													selected={filterData.supplier.selectedOption}
													disabled={supplierLoading}
													isLoading={supplierLoading}
													onChange={v => {
														onFilterChangeHandler('supplier', v);
													}}
												/>
											</SingleFilterWrapper>
											<DateRangeWrapper>
												<SectionFormLabel>Date</SectionFormLabel>

												<MonthPicker
													srcRange={filterData.dateRange.srcRange}
													stateRange={filterData.dateRange.stateRange}
													onConfirm={e => {
														setFilterData(prevState => ({
															...prevState,
															dateRange: {
																...prevState.dateRange,
																stateRange: e,
															},
														}));
													}}
												/>
											</DateRangeWrapper>
										</FilterWrapper>
										<div>
											<ButtonWrapper>
												<ApButtonSecondary onClick={handleGetMarketAnalysis}>
													Apply Filters
												</ApButtonSecondary>
											</ButtonWrapper>
										</div>
									</Header>
								</ExpandedModal>
							)}
							<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<ApButtonMain
									onClick={() => setShowSupplierModal(state => !state)}
								>
									Apply Filters
								</ApButtonMain>
							</div>
							<HighchartsReact
								highcharts={Highcharts}
								options={options}
								ref={chartRef}
							/>
						</>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default MarketEffectLineChart;
